import { useAppSelector } from './redux';
import { formatShipmentDate } from '../utils/formatShipmentDate';

export function useShipmentDateFormat() {
  const dateFormat =
    useAppSelector((s) => s.shipmentTracker.settings.data?.dateFormat) ??
    'DD/MM/YYYY';

  return (isoDate: string | null | undefined) =>
    formatShipmentDate(isoDate, dateFormat);
}
